<script>
    import {Line} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {hexToRgba} from '@coreui/coreui/dist/js/coreui-utilities'

    export default {
        components: {
            hexToRgba,
            CustomTooltips
        },
        extends: Line,
        mounted() {
            this.renderChart(
                {
                    labels: ['2016', '2017', '2018'],
                    datasets: [
                        {
                            label: 'SALAR',
                            backgroundColor: hexToRgba('#00D8FF', 70),
                            fill: true,
                            data: ['', '', 71657]
                        },
                        {
                            label: 'COHO',
                            backgroundColor: hexToRgba('#00ff20', 70),
                            fill: true,
                            data: ['', '', 10182]
                        }
                    ]
                },
                {
                    responsive: true,
                    scales: {
                        yAxes: [{
                            stacked: false,
                        }]
                    },
                    maintainAspectRatio: true,
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips,
                        intersect: false,
                        mode: 'index',
                        position: 'nearest',
                        callbacks: {
                            labelColor: function (tooltipItem, chart) {
                                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor}
                            }
                        }
                    }
                }
            )
        }
    }
</script>
